import { IconButton, Modal, ModalContent, PageLayout } from '@client/toolkit';
import { HiX } from 'react-icons/hi';
import { FaLock } from 'react-icons/fa6';
import ExioLogo from '../assets/images/logo_exio.svg?react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { PageContentAnimation } from './layout';
import { getRequiredPackageAccess, PackageTypeWithTier } from '../hooks/useUserPackages';

export function NoAccessModal() {
  const navigate = useNavigate();
  const { t: tGlobal } = useTranslation('global');
  return (
    <div className="fixed inset-0 bg-black/100 ">
      <Modal open onClose={() => null} size="md">
        <ModalContent className="p-6 space-y-4">
          <div className="text-right">
            <IconButton size="sm" onClick={() => navigate(-1)}>
              <HiX />
            </IconButton>
          </div>
          <div className="m-8 text-center">
            <ExioLogo className="mb-11 h-20 w-full text-center" />
            <p className="text-xl text-brand-primary mb-8">{tGlobal('permission.accessDeniedTitle')}</p>
            <p className="text-lg text-primary mb-16">{tGlobal('permission.accessDeniedDescription')}</p>
          </div>
        </ModalContent>
      </Modal>
    </div>
  );
}

interface NoPackageAccessPageProps {
  requiredPermissions?: PackageTypeWithTier[];
}

export function NoPackageAccessPage({ requiredPermissions }: NoPackageAccessPageProps = {}) {
  const { t: tGlobal } = useTranslation('global');
  const required = requiredPermissions ? getRequiredPackageAccess(requiredPermissions) : null;
  const supportEmail = 'support@exio.no';
  const [descBefore, descAfter] = tGlobal('permission.accessDeniedDescription').split(supportEmail);
  return (
    <PageLayout>
      <div className="flex items-center justify-center">
        <PageContentAnimation animateAlways>
          <div className="max-w-[60rem] relative text-left text-white flex flex-1 flex-col">
            <div className="m-8 text-center">
              {required ? (
                <div className="mx-auto my-8 w-full max-w-sm rounded-2xl border border-brand-primary/30 bg-surface-base p-8 text-center shadow-lg">
                  <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-brand-primary/10 ring-1 ring-brand-primary/30">
                    <FaLock className="h-5 w-5 text-brand-primary" />
                  </div>
                  <p className="mb-4 text-sm text-white/60">{tGlobal('permission.requiredAccessIntro')}</p>
                  <div className="flex items-center justify-center gap-3">
                    <span className="text-lg font-semibold text-white">
                      {tGlobal(`permission.packages.${required.packageName}`)}
                    </span>
                    <span className="rounded-full bg-brand-primary px-3 py-1 text-xs font-bold uppercase tracking-wide text-black">
                      {tGlobal(`permission.tiers.${required.tier}`)}
                    </span>
                  </div>
                </div>
              ) : (
                <ExioLogo className="mb-11 h-20 w-full text-center" />
              )}
              <p className="text-sm text-primary">
                {descBefore}
                <a href={`mailto:${supportEmail}`} className="text-brand-primary hover:underline">
                  {supportEmail}
                </a>
                {descAfter}
              </p>
            </div>
          </div>
        </PageContentAnimation>
      </div>
    </PageLayout>
  );
}
